export const GET_ORDER_GROUP_INFO = 'GET_ORDER_GROUP_INFO';
export const SET_ORDER_GROUP_INFO = 'SET_ORDER_GROUP_INFO';
export const SET_ORDER_GROUP_INFO_LOADING = 'SET_ORDER_GROUP_INFO_LOADING';
export const DELETE_ORDER_GROUP = 'DELETE_ORDER_GROUP';
export const SET_IS_ORDER_GROUP_DELETING = 'SET_IS_ORDER_GROUP_DELETING';

export const getOrderGroupInfoAction = payload => ({
	type: GET_ORDER_GROUP_INFO,
	payload,
});

export const setOrderGroupInfoAction = payload => ({
	type: SET_ORDER_GROUP_INFO,
	payload,
});

export const setOrderGroupInfoLoadingAction = payload => ({
	type: SET_ORDER_GROUP_INFO_LOADING,
	payload,
});

export const deleteOrderGroupAction = payload => ({
	type: DELETE_ORDER_GROUP,
	payload,
});

export const setIsOrderGroupDeletingAction = payload => ({
	type: SET_IS_ORDER_GROUP_DELETING,
	payload,
});

// --- Адреса ---
export const SET_IS_ADDRESSES_LOADING = 'orders-groups-modal/SET_IS_ADDRESSES_LOADING';
export const setIsAddressesLoadingAction = payload => ({
	type: SET_IS_ADDRESSES_LOADING,
	payload,
});

export const GET_ADDRESSES = 'orders-groups-modal/GET_ADDRESSES';
export const getAddressesAction = payload => ({
	type: GET_ADDRESSES,
	payload,
});

export const SET_ADDRESSES_SEARCH_VALUE = 'orders-groups-modal/SET_ADDRESSES_SEARCH_VALUE';
export const setAddressesSearchValueAction = payload => ({
	type: SET_ADDRESSES_SEARCH_VALUE,
	payload,
});

export const SET_ADDRESSES_OPTIONS = 'orders-groups-modal/SET_ADDRESSES_OPTIONS';
export const setAddressesAction = payload => ({
	type: SET_ADDRESSES_OPTIONS,
	payload,
});

// --- Периоды ---
export const SET_IS_PERIODS_LOADING = 'orders-groups-modal/SET_IS_PERIODS_LOADING';
export const setIsPeriodsLoadingAction = payload => ({
	type: SET_IS_PERIODS_LOADING,
	payload,
});

export const GET_PERIODS = 'orders-groups-modal/GET_PERIODS';
export const getPeriodsAction = payload => ({
	type: GET_PERIODS,
	payload,
});

export const SET_PERIODS = 'orders-groups-modal/SET_PERIODS';
export const setPeriodsAction = payload => ({
	type: SET_PERIODS,
	payload,
});

export const CREATE_ORDER_GROUP = 'orders-groups-modal/CREATE_ORDER_GROUP';
export const createOrderGroupAction = payload => ({
	type: CREATE_ORDER_GROUP,
	payload,
});

export const SET_IS_ORDER_GROUP_SAVING = 'orders-groups-modal/SET_IS_ORDER_GROUP_SAVING';
export const setIsOrderGroupSavingAction = payload => ({
	type: SET_IS_ORDER_GROUP_SAVING,
	payload,
});

// --- Автопарк ---
export const GET_AUTOPARKS = 'orders-groups-modal/GET_AUTOPARKS';
export const getAutoparksAction = payload => ({
	type: GET_AUTOPARKS,
	payload,
});

export const SET_AUTOPARKS = 'orders-groups-modal/SET_AUTOPARKS';
export const setAutoparksAction = payload => ({
	type: SET_AUTOPARKS,
	payload,
});

export const SET_IS_AUTOPARKS_LOADING = 'orders-groups-modal/SET_IS_AUTOPARKS_LOADING';
export const setIsAutoparksLoadingAction = payload => ({
	type: SET_IS_AUTOPARKS_LOADING,
	payload,
});
export const GET_TARIFF_TYPES = 'orders-groups-modal/GET_TARIFF_TYPES';
export const getTariffTypesAction = payload => ({
	type: GET_TARIFF_TYPES,
	payload,
});

export const SET_TARIFF_TYPES = 'orders-groups-modal/SET_TARIFF_TYPES';
export const setTariffTypesAction = payload => ({
	type: SET_TARIFF_TYPES,
	payload,
});

export const SET_IS_TARIFF_TYPES_LOADING = 'orders-groups-modal/SET_IS_TARIFF_TYPES_LOADING';
export const setIsTariffTypesLoadingAction = payload => ({
	type: SET_IS_TARIFF_TYPES_LOADING,
	payload,
});

// --- Типы ---
export const GET_TYPES = 'orders-groups-modal/GET_TYPES';
export const getTypesAction = payload => ({
	type: GET_TYPES,
	payload,
});

export const SET_TYPES = 'orders-groups-modal/SET_TYPES';
export const setTypesAction = payload => ({
	type: SET_TYPES,
	payload,
});

export const SET_IS_TYPES_LOADING = 'orders-groups-modal/SET_IS_TYPES_LOADING';
export const setIsTypesLoadingAction = payload => ({
	type: SET_IS_TYPES_LOADING,
	payload,
});

// --- Конфиги ---
export const GET_CONFIGS = 'orders-groups-modal/GET_CONFIGS';
export const getConfigsAction = payload => ({
	type: GET_CONFIGS,
	payload,
});

export const SET_CONFIGS = 'orders-groups-modal/SET_CONFIGS';
export const setConfigsAction = payload => ({
	type: SET_CONFIGS,
	payload,
});

export const SET_IS_CONFIGS_LOADING = 'orders-groups-modal/SET_IS_CONFIGS_LOADING';
export const setIsConfigsLoadingAction = payload => ({
	type: SET_IS_CONFIGS_LOADING,
	payload,
});

// --- Типы транспорта ---
export const GET_TRANSPORT_TYPES = 'orders-groups-modal/GET_TRANSPORT_TYPES';
export const getTransportTypesAction = payload => ({
	type: GET_TRANSPORT_TYPES,
	payload,
});

export const SET_TRANSPORT_TYPES = 'orders-groups-modal/SET_TRANSPORT_TYPES';
export const setTransportTypesAction = payload => ({
	type: SET_TRANSPORT_TYPES,
	payload,
});

export const SET_IS_TRANSPORT_TYPES_LOADING = 'orders-groups-modal/SET_IS_TRANSPORT_TYPES_LOADING';
export const setIsTransportTypesLoadingAction = payload => ({
	type: SET_IS_TRANSPORT_TYPES_LOADING,
	payload,
});

// --- Режимы ---
export const GET_MODES = 'orders-groups-modal/GET_MODES';
export const getModesAction = payload => ({
	type: GET_MODES,
	payload,
});

export const SET_MODES = 'orders-groups-modal/SET_MODES';
export const setModesAction = payload => ({
	type: SET_MODES,
	payload,
});

export const SET_IS_MODES_LOADING = 'orders-groups-modal/SET_IS_MODES_LOADING';
export const setIsModesLoadingAction = payload => ({
	type: SET_IS_MODES_LOADING,
	payload,
});

export const RESET_STATE = 'orders-groups-modal/RESET_STATE';
export const resetStateAction = () => ({
	type: RESET_STATE,
});

export const UPDATE_ORDER_GROUP = 'orders-groups-modal/UPDATE_ORDER_GROUP';
export const updateOrderGroupAction = payload => ({
	type: UPDATE_ORDER_GROUP,
	payload,
});
